'use client';

import {
  ServicePageNavigationFragment,
  ServicePageStoreFragment,
} from '@business/gql/graphql';
import { Popover, Transition } from '@headlessui/react';
import { cn } from '@ngg/storefront-utils';
import { Maybe } from 'graphql/jsutils/Maybe';
import { Fragment, useState } from 'react';
import Icon from '../icon/icon';
import { ListItem } from './Listitem';
import { StoreInfo } from './StoreInfo';
import useDictionary from '@utils/hooks/useDictionary';
import { Heading } from '../Heading/Heading';

export const MenuItems = ({
  navigations,
  storeData,
  slug,
  locale,
}: {
  navigations?: Maybe<ServicePageNavigationFragment>[] | null;
  storeData?: Maybe<ServicePageStoreFragment>;
  slug: string;
  locale: string | undefined;
}) => {
  const dictionary = useDictionary({ keys: ['close', 'back'] });
  const [item, setItem] = useState<ServicePageNavigationFragment | null>(null);

  const handleClickBack = () => {
    setItem(null);
  };

  return (
    <Transition
      as={Fragment}
      enter="transition-transform"
      enterFrom="-translate-x-full"
      enterTo="translate-x-0"
      leave="transition-transform"
      leaveFrom="translate-x-0"
      leaveTo="-translate-x-full"
      beforeEnter={() => {
        setItem(null);
        document?.querySelector('body')?.classList.add('overflow-hidden');
      }}
      afterLeave={() =>
        document?.querySelector('body')?.classList.remove('overflow-hidden')
      }>
      <Popover.Panel
        as="nav"
        className="fixed inset-0 z-30 w-4/5 overflow-y-auto bg-main text-sm lg:hidden">
        {({ close }) => (
          <div className="flex min-h-[100vh] flex-col">
            <div
              className={cn(
                'flex w-full items-center justify-between bg-main px-4',
                item ? 'h-14' : 'h-10',
              )}>
              {item ? (
                <button
                  className="flex items-center text-base"
                  type="button"
                  onClick={handleClickBack}>
                  <Icon name="rightArrowWithTail" className="rotate-180" />
                  {dictionary.back}
                </button>
              ) : null}
              <button
                type="button"
                className="ml-auto text-xs  underline"
                onClick={() => close()}>
                {dictionary.close}
              </button>
            </div>

            {!item && navigations
              ? navigations.map((navigation) => (
                  <div
                    key={navigation?.sys?.id}
                    className="border-gray-150 border-t">
                    <Heading
                      as="h3"
                      className="flex h-10 items-center px-4 font-bold">
                      {navigation?.title}
                    </Heading>
                    <ul>
                      {navigation?.sublinksCollection?.items?.map((link) => {
                        if (!link) return null;
                        return (
                          <ListItem
                            slug={slug}
                            key={link?.sys?.id}
                            link={link}
                            locale={locale}
                            onClose={() => close()}
                          />
                        );
                      })}
                    </ul>
                  </div>
                ))
              : null}

            <div className="flex flex-1 items-start border-t border-borderColor bg-beige">
              {storeData ? (
                <StoreInfo
                  storeData={storeData}
                  className="mb-6 bg-beige px-4 pt-4 lg:hidden"
                />
              ) : null}
            </div>
          </div>
        )}
      </Popover.Panel>
    </Transition>
  );
};
